// SettingsHubPage — Subscription, API keys, notifications, social, academy

import { HubLayout } from './HubLayout';

export function SettingsHubPage() {
  return (
    <HubLayout
      title="Settings"
      testIdRoot="hub-settings"
      hero={{
        title: 'Preferences',
        subtitle: 'Subscription, API, advanced',
        emoji: '⚙️',
        gradient: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)',
        stats: [
          { label: 'Plan',     value: 'Mid',     sub: '$149/mo' },
          { label: 'API keys', value: '2',       sub: 'active' },
          { label: 'Auto-renew', value: 'On',   sub: '08-12', color: '#34C759' },
        ],
      }}
      quickActions={[
        { to: '/portal/subscription',   label: 'Billing',    icon: '💳', testId: 'hub-settings-qa-billing' },
        { to: '/portal/api-keys',       label: 'API keys',   icon: '🔑', testId: 'hub-settings-qa-api' },
        { to: '/portal/notifications-settings', label: 'Notif', icon: '🔔', testId: 'hub-settings-qa-notif' },
      ]}
      sections={[
        {
          title: 'Subscription & API',
          items: [
            { to: '/portal/subscription',           icon: '⭐', iconBg: 'linear-gradient(135deg, #FF9500 0%, #FFD60A 100%)', label: 'Subscription & billing',  sub: 'Mid tier · $149/mo · renews 08-12' },
            { to: '/portal/subscriptions',          icon: '📋', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'All subscriptions',       sub: 'Manage plans' },
            { to: '/portal/api-keys',               icon: '🔑', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'API keys',                sub: '2 active · Pro only',      badge: { text: 'Pro', color: 'white', bg: '#1C1C1E' } },
          ],
        },
        {
          title: 'Preferences',
          items: [
            { to: '/portal/showcase/production',    icon: '🎨', iconBg: 'linear-gradient(135deg, #FF2D55 0%, #5856D6 100%)', label: 'Production suite',        sub: 'Components, icons, brands' },
            { to: '/portal/settings',               icon: '⚙️', iconBg: 'linear-gradient(135deg, #8E8E93 0%, #48484A 100%)', label: 'General settings',        sub: 'All app settings' },
            { to: '/portal/notifications',          icon: '🔔', iconBg: 'linear-gradient(135deg, #FF9500 0%, #C93400 100%)', label: 'Notifications',          sub: 'Inbox + preferences' },
            { to: '/portal/notifications-settings', icon: '🎛️', iconBg: 'linear-gradient(135deg, #FF3B30 0%, #B82B22 100%)', label: 'Notification preferences', sub: 'Push · Email · SMS · In-app' },
            { to: '/portal/feed',                   icon: '🌍', iconBg: 'linear-gradient(135deg, #5856D6 0%, #FF2D55 100%)', label: 'Social feed preferences',  sub: 'Following, mute, copy-trade' },
            { to: '/portal/academy',                icon: '🎓', iconBg: 'linear-gradient(135deg, #34C759 0%, #248A3D 100%)', label: 'Academy',                  sub: 'Courses, progress, certificates' },
            { to: '/portal/course/fundamentals-101', icon: '📘', iconBg: 'linear-gradient(135deg, #007AFF 0%, #0040DD 100%)', label: 'Course detail',          sub: 'Single course view' },
          ],
        },
        {
          title: 'Notifications',
          items: [
            { to: '/portal/notification/nt-001', icon: '📬', iconBg: 'linear-gradient(135deg, #5856D6 0%, #3634A3 100%)', label: 'Notification detail', sub: 'Single notification' },
          ],
        },
      ]}
      footerNote="Settings sync across all your devices."
    />
  );
}
